<template>
    <div v-if="isSlim" style="display: flex; justify-content: space-between; align-items: center" v-fs-block>
        <code class="text inline-s">{{paymentCard.pan}}</code> <v-payment-card :type="paymentCard.brand"/>
    </div>
    <div v-else-if="isCompact" class="grid-fitted grid-unstackable" v-fs-block>
        <div class="grid-item no-flex inline-s">
            <v-payment-card :type="paymentCard.brand"/>
            <v-flags :country-code="paymentCard.country"/>
        </div>
        <div class="grid-item grid-item-primary">
            <p><code class="text inline-s">{{paymentCard.pan}}</code></p>
            <p>Exp. {{paymentCard.expires}}</p>
            <p v-if="paymentCard.bankName">{{paymentCard.bankName}}</p>
            <v-contact :contact="paymentCard.address"></v-contact>
            <contact-form-modal
                v-if="$auth.editPaymentInstruments.isAllowed && isAddressEditable && hasInjectedMethods"
                title="Edit Address"
                class="no-flex"
                :value="instrument.billingAddress"
                :custom-fields="contactsCustomFields"
                @input="updateContact($event)"
                :canDelete="false"/>
        </div>
        <div class="grid-item no-flex">
            <v-icon-button v-if="showSticky" type="basic" size="small" class="inline-xs"
                           tooltip="Update Sticky Gateway" @click="$emit('open-sticky')">
                <v-icon icon="sticky-note"/>
            </v-icon-button>
            <instrument-fingerprint :fingerprint="panFingerprint"/>
        </div>
    </div>
    <div v-else v-fs-block>
        <div class="grid-fitted grid-unstackable align-items-center">
            <div class="grid-item">
                <p>{{paymentCard.name}}</p>
            </div>
            <div class="grid-item no-flex display-flex align-items-center">
                <instrument-fingerprint :fingerprint="panFingerprint"/>
                <v-icon-button v-if="showSticky" type="basic" size="small" class="inline-xs"
                               tooltip="Update Sticky Gateway" @click="$emit('open-sticky')">
                    <v-icon icon="sticky-note"/>
                </v-icon-button>
                <v-payment-card :type="paymentCard.brand"/>
            </div>
        </div>
        <span class="payment-instrument-card-pan">
            {{paymentCard.pan}}
        </span>
        <p v-if="paymentCard.bankName">{{paymentCard.bankName}}</p>
        <div class="stack-s">
            <span class="payment-instrument-label">Expires</span>
            <span class="payment-instrument-card-exp-date">{{paymentCard.expires}}</span>
        </div>
        <div class="grid-fitted grid-unstackable">
            <div class="grid-item">
                <span class="payment-instrument-card-customer">{{paymentCard.customer}}</span>
            </div>
            <div class="grid-item no-flex text-right">
                <v-flags :country-code="paymentCard.country"/>
            </div>
        </div>
    </div>
</template>

<script>
    import {vIcon, vIconButton} from '@/components/form';
    import vModal from '@/components/modal/v-modal';
    import vPaymentCard from '@/components/v-payment-card';
    import vFlags from '@/components/v-flags';
    import fullName from '@/common/helpers/full-name';
    import InstrumentFingerprint from '../instrument-fingerprint';
    import ContactModel from '@/common/models/contact-model';
    import vContact from '@/components/v-contact';
    import ContactFormModal from '@/components/contact-manager/contact-form-modal';

    export default {
        name: 'payment-card-view',
        inject: {
            updatePaymentInstrument: {default: null},
            contactsCustomFields: {default: null},
        },
        components: {
            vModal,
            vIcon,
            vIconButton,
            vPaymentCard,
            vFlags,
            InstrumentFingerprint,
            vContact,
            ContactFormModal,
        },
        props: {
            instrument: Object,
            isCompact: {
                type: Boolean,
                default: true,
            },
            isSlim: {
                type: Boolean,
                default: false,
            },
            showSticky: Boolean,
            isAddressEditable: {
                type: Boolean,
                default: true,
            },
        },
        computed: {
            hasInjectedMethods() {
                return this.updatePaymentInstrument !== null
                    && this.contactsCustomFields !== null;
            },
            panFingerprint() {
                return this.instrument.panFingerprint;
            },
            paymentCard() {
                return {
                    brand: this.instrument.brand,
                    pan: this.paymentCardPan(),
                    expires: `${this.paymentCardExpMonth()}/${this.paymentCardExpYear()}`,
                    customer: fullName(this.instrument.billingAddress),
                    country: this.instrument.bankCountry,
                    bankName: this.instrument.bankName,
                    address: new ContactModel(this.instrument.billingAddress),
                };
            },
        },
        methods: {
            format(number) {
                return this.$filter.number(number);
            },
            paymentCardPan() {
                return this.$filters.pan(
                    {
                        bin: this.instrument.bin,
                        lastFour: this.instrument.last4,
                        brand: this.instrument.brand,
                    },
                );
            },
            paymentCardExpMonth() {
                return this.$filters.number(this.instrument.expMonth, {minimumIntegerDigits: 2});
            },
            paymentCardExpYear() {
                if (this.instrument.expYear !== null) {
                    return this.instrument.expYear.toString().slice(2);
                }
                return '';
            },
            updateContact(data) {
                this.updatePaymentInstrument({instrument: this.instrument, data});
            },
        },
    };
</script>
